import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

// Singleton
let instance;

export default class Analytics {
  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  getSatellite() {
    if (!this.satellite) {
      this.setSatellite(window._satellite);
    }

    return this.satellite;
  }

  getDataLayer() {
    // in case if dataLayer was changed in window
    if (!window.dataLayer) {
      this.dataLayer = window.dataLayer = [];
    } else if (!this.dataLayer || this.dataLayer !== window.dataLayer) {
      this.dataLayer = window.dataLayer;
    }

    return this.dataLayer;
  }

  setSatellite(satellite) {
    this.satellite = satellite;
  }

  // tracks generic error
  trackError(message, pageName) {
    const s = this.getSatellite();

    this.setPageName(pageName || 'Unknown Error');

    if (message) {
      s.setVar('error message', message);
    }

    s.track(Analytics.TRACK_STRING_ERROR);
  }

  addViewableModule(moduleName) {
    this.addModuleAvailable(moduleName);
  }

  clearViewableModules() {
    this.clearModulesAvailable();
  }

  trackVirtualPageview(pageName) {
    if (pageName) {
      this.setPageName(pageName);
    }

    this.getDataLayer().push({ event: 'virtualPageview' });
  }

  trackEvent({ category, action, label, value, callback } = {}) {
    if (!category || !action) {
      return;
    }

    let eventLabel = label || '';

    if (typeof label === 'string' && label.length > 2 && label[0] === '$' && label[1] === '.') {
      eventLabel = get(this, label.substr(2));
    }
    else if (typeof label === 'function') {
      eventLabel = label(this.store);
    }

    this.getDataLayer().push({
      event: 'eventTracker',
      'data-event-category': category,
      'data-event-action': action,
      'data-event-label': eventLabel,
      'data-event-value': value || 0,
      eventCallback: callback,
    });
  }

  track(type, ...args) {
    const s = this.getSatellite();

    if (!s) {
      return false;
    }

    s.setVar('error message', '');

    if (isFunction(this[type])) {
      this[type](...args);

      return true;
    }

    console.warn('not found', args);

    return false;
  }
}

Analytics.TRACK_STRING_ERROR = 'mytm-error';
